import stickybits from 'stickybits'

const stickyOpts = {
    stickyBitStickyOffset: 30
}

stickybits('[data-sticky]', stickyOpts);

theme.cart = {

    /*
        Initialise the Cart.
        @link https://cartjs.org/

        @param - debug true|false
    */
    init: function(debug) {

        console.info('%c[Sureify Cart] ----- Initialising', 'color: #acdd1e;')

        CartJS.init(cart, {
            debug: debug
        });
        
        // Add some listeners to the cart
        this._addListeners(cart);

        // Hide the loader
        this._bootUI()

        // Update cart count
        this._updateCount(cart)

    },

    /*
        Cart Error
        @return Array
    */
    error: function(data) {
        console.error('[Sureify Cart] ----- Error]', data.responseJSON.description)
        this._updateMessaging('error', data.responseJSON.description)
    },

    /*
        Cart Success
        @return Array
    */
    success: function (data) {
        console.info('%c[Sureify Cart] ----- Success]', 'color: #75f582;')
        this._updateMessaging('success', theme.language.cart_success)
        this._updateCount()
    },
    
    /*
        Add an item to the cart

        @return void
        @param jQuery event
        @link - https://cartjs.org/pages/guide#core-api-adding-items
    */
    addItem: function(event) {

        // Prevent link
        event.preventDefault()

        let $formData = $(event.currentTarget).closest("form");

        // The Variant ID
        let id = $formData.find('[name="id"]').val()

        // The quantity
        let qty = $formData.find('[name="quantity"]').val()

		// The Properties
		let properties = {}
		$formData.find('input[name^="properties"]').each(function() {
			let propertyName = $(this).attr('name')
			let matches = propertyName.match(/\[(.*?)\]/);

			if (matches) {
				propertyName = matches[1]
			}
			
			properties[propertyName] = $(this).val()
		})

        // Add the item
        CartJS.addItem(id, qty, properties, {
            "success": this.success.bind(this),
            "error": this.error.bind(this)
        });

        // Show the sidebar
        this._showSidebar()

    },
    /*
        Add items to the cart

        @return event - The event
        @global cart - The current cart (window.cart)

        Multiple items method not in use by default
    */
    addItems: function(event) {},
    /*
        @return event - The event
        @global cart - The current cart (window.cart)

        Triggered whenever Cart.js begins to process the request queue.
        Note that if you make multiple Ajax-triggered calls to Cart.js (say, two calls to addItem in a row), 
        this event will still only fire once.
    */
    started: function(event, cart) {

        $('[data-cartbutton-spinner-text]').addClass('hidden invisible')
        $('[data-cartbutton-spinner]').removeClass('hidden invisible')

    },
    /*
        @return event - The event
        @global cart - The current cart (window.cart)

        Triggered whenever Cart.js begins to process the request queue.
        Note that if you make multiple Ajax-triggered calls to Cart.js (say, two calls to addItem in a row), 
        this event will still only fire once.
    */
    completed: function(event, cart) {

        $('[data-cartbutton-spinner-text]').removeClass('hidden invisible')
        $('[data-cartbutton-spinner]').addClass('hidden invisible')

        if (cart.item_count == 0) {
            $('[data-basket-empty]').removeClass('hidden')
            $('[data-cart-sidebar]').removeClass('is--open')
        }

        // Update the count
        this._updateCount();

    },
    /*
        Add some vent listeners for the Cart
        @link https://cartjs.org/pages/reference#events
    */
    _addListeners() {
        
        // The cart request completed. 
        $(document).on('cart.requestComplete', this.completed.bind(this));

        // The cart request started. 
        $(document).on('cart.requestStarted', this.started.bind(this));
        
        // Add an item to the cart.
        $('body').on('click', 'button[name="add"]', this.addItem.bind(this))

        // Close the sidevar
        $('[data-close-cart-sidebar]').on('click', function(e) {
            e.preventDefault()
            $('[data-cart-sidebar]').removeClass('is--open');
            $('[data-cart-message]').addClass('hidden');
        })
        
    },

    _showSidebar() {
        
        // Open the sidevar
        $('[data-cart-sidebar]').addClass('is--open');

        // Figure out the heights incase of overflow.
        let header = $('[data-cart-sidebar-header]').outerHeight()
        let footer = $('[data-cart-sidebar-footer]').outerHeight()
        let body = $('[data-cart-sidebar]').outerHeight()

        // Set the height for the inner portions.
        let calc = (body - header - footer)
        $('[data-cart-lines]').height(calc)
    },

    /*
        Show the basket when it's ready
    */
    _bootUI() {

        $('[data-cart-view]').removeClass('hidden invisible')
        $('[data-cart-loading]').addClass('hidden invisible')

        let $basketContainer = $('.basket-container');
        if ($basketContainer.length > 0) {
            let lastScrollTop = 0
            let stickyBasket = $('[data-sticky]')
            let stickyBasketPosition = ($(stickyBasket).position().top - $(stickyBasket).height());
            $(window).on('scroll', _.debounce(() => {
        
                let top = window.pageYOffset || document.documentElement.scrollTop;
        
                // Downward!
                if (top > lastScrollTop) {
                    // Have we reached the target div?
                    if (top > stickyBasketPosition) {
                        $('[data-fixed-checkout-button]').fadeOut(300)
                    } else {
                        $('[data-fixed-checkout-button]').fadeIn(300)
                    }
                // Upward!
                } else {
                    // User potentially doesn't want to checkout to hide the button
                    $('[data-fixed-checkout-button]').fadeOut(300)
                }
        
                // For negative scrolling effects on mobile
                lastScrollTop = top <= 0 ? 0 : top;
        
            }, 100))       
        }

   },
    /*
        Update the cart count icon
    */
    _updateCount() {
        
        if (CartJS.cart.item_count > 0) {
            $('[data-cart-count]').removeClass('hidden')
        } else {
            $('[data-cart-count]').addClass('hidden')
        }

        $('[data-cart-count]').html(CartJS.cart.item_count);

    },
    /*
        Update the cart count icon
    */
    _updateMessaging(type, message) {

        console.info('%c[Sureify Cart] ----- Update Messaging]', 'color: #75f582;')

        let messageContainer = $('[data-cart-message]')
        let product_name = 'Product'

        if ($('[data-product-title]').length > 0) {
            product_name = $('[data-product-title]').text()
        }

        if (type == 'error') {
            messageContainer.removeClass('cart--success')
            messageContainer.addClass('cart--error')
        } else {
            message = message.replace('{product_name}', product_name)
            messageContainer.removeClass('cart--error')
            messageContainer.addClass('cart--success')
        }

        messageContainer.removeClass('hidden')
        messageContainer.html(message)

    }
}

$(function() {
    
    theme.cart.init(false)

});
   